// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_10464","holder":"_10096","noSafeArea":"_51"};